import createVueComponent from '../createVueComponent';
var Rss = createVueComponent('RssIcon', [['path', {
  d: 'M4 11a9 9 0 0 1 9 9',
  key: 'pv89mb'
}], ['path', {
  d: 'M4 4a16 16 0 0 1 16 16',
  key: 'k0647b'
}], ['circle', {
  cx: '5',
  cy: '19',
  r: '1',
  key: 'bfqh0e'
}]]);
export default Rss;